import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const invitation_collaborate_project = apiUrl + "/invitation_collaborate_project";

const routes = {
  label: "Invitation Collaborate Project",
  root: invitation_collaborate_project,
  send: invitation_collaborate_project + "/send",
  accept: invitation_collaborate_project + "/accept",
  reject: invitation_collaborate_project + "/reject",
  get_my_pending_invitations_received: invitation_collaborate_project + "/get_my_pending_invitations_received",
};

export const InvitationCollaborateProject = {
  get_my_pending_invitations_received: () => postWithToken(routes.get_my_pending_invitations_received),
  accept: (invitation_id) => postWithToken(routes.accept, { invitation_id }),
  reject: (invitation_id) => postWithToken(routes.reject, { invitation_id }),
  send: (ids, receiver_id) => postWithToken(routes.send, { ids, receiver_id }),
};
